module.exports = __webpack_public_path__ + "img/journey_orchestration.66c824b1.svg";